import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@offerzen/pinata-shame'
import styles from './styles'

const WorkHistoryList = ({ addBlankWorkHistory, children }) => (
  <Fragment>
    <p className={styles.description}>We&apos;ll make sure your profile is hidden from your current employer.</p>

    <div>{children}</div>

    <Button label="Add work experience" variant="outlined" size="medium" theme="primary" onClick={() => addBlankWorkHistory()} />
  </Fragment>
)

WorkHistoryList.propTypes = {
  addBlankWorkHistory: PropTypes.func,
  children: PropTypes.node,
}

export default WorkHistoryList
